<div class="version-board-header"
     [ngClass]="{ '-closed': version.isClosed(), '-locked': version.isLocked() }"
     *ngIf="version">
  <h2 [textContent]="version.name"
      class="editable-toolbar-title--fixed">
  </h2>
  <span class="version-board-header--info-row -italic -small-font"> {{version.endDate}}  </span>
</div>
